import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  ActivityModel,
  ActivityMutationInput,
  ActivityDeleteInput,
  ActivityUpdateInput,
} from './model';

export function useCreateActivity(
  options?: UseMutationOptions<
    ApiResult<ActivityModel>,
    ApiError,
    ActivityMutationInput
  >,
): UseMutationResult<
  ApiResult<ActivityModel>,
  ApiError,
  ActivityMutationInput
> {
  return useMutation<ApiResult<ActivityModel>, ApiError, ActivityMutationInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: 'activities',
        method: 'POST',
        classType: ActivityModel,
        body,
      });
    },
    options,
  );
}

export function useUpdateActivity(
  options?: UseMutationOptions<
    ApiResult<ActivityModel>,
    ApiError,
    ActivityUpdateInput
  >,
): UseMutationResult<ApiResult<ActivityModel>, ApiError, ActivityUpdateInput> {
  return useMutation<ApiResult<ActivityModel>, ApiError, ActivityUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `activities/${body.activityId}`,
        method: 'PUT',
        classType: ActivityModel,
        body: body.body,
      });
    },
    options,
  );
}

export function useDeleteActivity(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    ActivityDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, ActivityDeleteInput> {
  return useMutation<{ message: string }, ApiError, ActivityDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `activities/${body.activityId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}
